import * as constants from '../constants/constants';
import errorHandler from '../utils/errorHandler';
import API from '../utils/API';
import { toastError } from '../utils/toastMessage';

export const setAllFolders = (data) => {
  return {
    type: constants.SET_ALL_FOLDERS,
    payload: {
      folders: data.folders,
      pages: data.pages,
    },
  };
};

export const changeFoldersSelector = (selectedFolderId) => {
  return {
    type: constants.CHANGE_FOLDER_SELECTION,
    payload: {
      selectedFolderId,
    },
  };
};

export const getFolderError = (message) => {
  return {
    type: constants.GET_ALL_FOLDERS_ERROR,
    payload: { message },
  };
};

export const isLoadFolder = () => {
  return {
    type: constants.IS_LOAD_FOLDER,
  };
};

export const isLoadFolderEnd = () => {
  return {
    type: constants.IS_LOAD_FOLDER_END,
  };
};

export const isLoadTemplateFolders = () => {
  return {
    type: constants.IS_LOAD_TEMPLATE_FOLDERS,
  };
};

export const setTemplateFolders = (payload) => {
  return {
    type: constants.SET_TEMPLATE_FOLDERS,
    payload: payload,
  };
};

export const transformTemplateFolders = (data) => {
  return (dispatch) => {
    const payload = data.templateFolders.map((folder) => {
      return {
        key: folder.id,
        value: folder.title,
        text: folder.title,
        created_at: folder.created_at,
        updated_at: folder.updated_at,
      };
    });

    dispatch(setTemplateFolders(payload));
  };
};

export const getTemplateFolders = () => {
  return (dispatch) => {
    dispatch(isLoadTemplateFolders());
    API.get(`/templateFolder`)
      .then((response) => {
        dispatch(transformTemplateFolders(response.data.data));
      })
      .catch(function (error) {
        if (error.response && error.response.status === 404) {
          dispatch(getFolderError('Результатов не найдено.'));
        }
        const errorConfig = {
          404: {
            message: 'Шаблонов не найдено',
          },
        };
        if (error.response) {
          errorHandler(error.response.status, errorConfig);
        }
      });
  };
};

export const toggleRecommendedTemplate = () => {
  return {
    type: constants.IS_SHOW_RECOMMENDED_TEMPLATE,
  };
};

export const closeRecommendedTemplate = () => {
  return {
    type: constants.CLOSE_RECOMMENDED_TEMPLATE,
  };
};

export const noRecommendedTemplatesFound = () => {
  return (dispatch) => {
    toastError('Подходящие шаблоны не найдены. Показаны все шаблоны');
    dispatch(closeRecommendedTemplate());
  };
};

export const getFolders = (
  pageNumber = 1,
  name = '',
  tags = '',
  userId = '',
  selectedComplexPeriod = '',
) => {
  let queryStrTagsIds = '';
  tags ? (queryStrTagsIds = tags.join('|')) : (queryStrTagsIds = '');
  return (dispatch) => {
    dispatch(isLoadFolder());
    API({
      url: `/template`,
      method: 'GET',
      params: {
        template: 1,
        page: pageNumber,
        title: name,
        tags: queryStrTagsIds,
        userId,
        selectedComplexPeriod,
      },
    })
      .then((response) => {
        !response.data.data.recommendations && dispatch(noRecommendedTemplatesFound());
        dispatch(setAllFolders(response.data.data));
        dispatch(isLoadFolderEnd());
      })
      .catch(function (error) {
        if (error.response && error.response.status === 404) {
          dispatch(getFolderError('Результатов не найдено.'));
          dispatch(isLoadFolderEnd());
        }
        const errorConfig = {
          404: {
            message: 'Шаблонов не найдено',
          },
        };
        if (error.response) {
          errorHandler(error.response.status, errorConfig);
          dispatch(isLoadFolderEnd());
        }
      });
  };
};

export const openAllFolderModal = () => {
  return {
    type: constants.OPEN_ALL_FOLDER_MODAL,
  };
};

export const closeAllFolderModal = () => {
  return {
    type: constants.CLOSE_ALL_FOLDER_MODAL,
  };
};

export const openCreateFolderModal = () => {
  return {
    type: constants.OPEN_CREATE_FOLDER_MODAL,
  };
};

export const closeCreateFolderModal = () => {
  return {
    type: constants.CLOSE_CREATE_FOLDER_MODAL,
  };
};

export const setChoosedTemplateTags = (tags) => {
  return {
    type: constants.SET_CHOOSED_TEMPLATE_TAGS,
    payload: {
      tags,
    },
  };
};



// WEBPACK FOOTER //
// ./src/actions/folders.js